<template>
  <div class="app-info">
    <div class="d-flex justify-content-between">
      <BuildNumber />
      <UserInfo class="ml-2" />
      <NodeStatus class="ml-2" />
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import BuildNumber from '@/components/AppInfo/BuildNumber.vue';
  import NodeStatus from '@/components/AppInfo/NodeStatus.vue';
  import UserInfo from '@/components/AppInfo/UserInfo.vue';

  @Component({
    components: {
      BuildNumber,
      NodeStatus,
      UserInfo,
    },
  })
  export default class AppInfo extends Vue {}
</script>

<style scoped lang="scss">
  .app-info {
    position: absolute;
    bottom: 0.5em;
    right: 2.5em;
    opacity: 0.6;
  }
</style>
